module.exports = __webpack_public_path__ + "static/media/232.cd3e0d98.webp";